
import { Typography } from "@mui/material";
import { Modal } from "../Modal/Modal";
import { ModalHeader } from "../Modal/ModalHeader";
import { ModalBody } from "../Modal/ModalBody";
import { ModalFooter } from "../Modal/ModalFooter";
import { useEffect } from "react";

export const ModalConfirm: React.FC<any> = (props): JSX.Element | any => {
  const { open, title, text, closeModal, clearState, onConfirm, status = false } = props

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault()
        onConfirm()
      }
      if (event.key === "Escape") {
        event.preventDefault()
        closeModal()
      }
    }

    if (open) {
      document.addEventListener("keydown", handleKeyDown)
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [open, onConfirm, closeModal])

  return (
    <Modal open={open} handleClose={closeModal} disableBackdropClick size="sm">
      <ModalHeader
        text={title || "¿Está seguro de eliminar el elemento seleccionado?"}
        className="positionElements"
        onCancel={closeModal}
        clearState={clearState}
      />
      <ModalBody>
        <Typography variant="subtitle1" className="textColor">
          {text || 'Si estás seguro, haz click en el botón "Aceptar" y el registro será eliminado'}
        </Typography>
      </ModalBody>
      <ModalFooter
        confirmText="Aceptar"
        onConfirm={onConfirm}
        cancelText="Cancelar"
        onCancel={closeModal}
        className="modal-confirm-footer"
        clearState={clearState}
        loadingConfirmText={status}
      />
    </Modal>
  )
}